/* eslint-disable */

import React, { useState } from "react";

import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import {
  fetchAdvertisementUpload,
  fetchGraphQL,
} from "../../../services/api-raindrop.js";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";
import RaindropAdvertisement from "../../../ui-components/raindrop-advertisement/raindrop-advertisement.tsx";
import { useNavigate } from "react-router-dom";
import { Size } from "../../../logic/enums.ts";

const CirrusAdvertisementCreate = ({
  organisation,
  currentOrganisationUser,
}) => {
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [imageUri, setImageUri] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const onUploadAdvert = async () => {
    setIsLoading(true);

    const response = await fetchGraphQL(`
      mutation {
        advertisementCreate(
          organisationId: "${organisation.id}",
        ){
          id
        }
      }
    `);

    const advert = await fetchAdvertisementUpload({
      advertisementId: response.data.advertisementCreate.id,
      file: file,
    });

    setIsLoading(false);
    navigate(`/cirrus/advertisements`);
  };

  return (
    <div className="flex flex-row gap-4 w-full">
      <div className={`flex flex-col w-full max-w-md h-full gap-6  pb-6`}>
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-bold">Upload your new Advert</h1>
          <p className="text-color-dark-text-secondary">
            Adverts are shown with the Raindrop app.
          </p>
        </div>

        <RaindropInputFile
          onChange={(e) => setFile(e.target.files[0])}
          setImageUrl={setImageUri}
        />

        <RaindropButton
          onClick={onUploadAdvert}
          title={"Upload Advert"}
          size={Size.Large}
          style={ButtonStyle.Primary}
          isLoading={isLoading}
        />
      </div>
      <div className="flex flex-col gap-6 w-full max-w-md">
        <h2 className="text-3xl font-bold">Preview of Ad</h2>
        {/* <JSONBlob data={organisation} /> */}

        <RaindropAdvertisement
          advertisementSrc={imageUri}
          organisationId={organisation.id}
          organisationName={organisation.name}
          organisationSrc={organisation.presigned_url_logo}
        />
      </div>
    </div>
  );
};

export default CirrusAdvertisementCreate;
